import { DocumentListView } from '@/components/documents/DocumentListView'
import { ExpenseInbox } from '@/components/documents/ExpenseInbox'

export default function ExpensesPage() {
  return <DocumentListView kind="expense" aside={(period) => <ExpenseInbox {...period} />} />
}
